import { ReactElement } from 'react'

import queryString from 'query-string'
import { Navigate, useLocation } from 'react-router-dom'

import { getPath } from 'routing/pagePaths'

import { AdvertisingView } from '../AmazonAdvertisingSummaryPage'

interface RedirectToAdvertisingViewProps {
    view: AdvertisingView
}

export const RedirectToAdvertisingView = ({
    view,
}: RedirectToAdvertisingViewProps): ReactElement => {
    const location = useLocation()
    const params = queryString.parse(location.search)
    const search = queryString.stringify({ ...params, view })

    return (
        <Navigate
            replace
            to={{
                pathname: getPath('campaignsSummaryPage'),
                search: `?${search}`,
            }}
        />
    )
}
